(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibsy-collection"] && !Shopify.designMode) return;
  try {
    
  class NibsyCollection extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('[data-add-all]');
      if (!btn) return;
      btn.addEventListener('click', async () => {
        let items = [];
        try { items = JSON.parse(btn.dataset.items || '[]'); } catch (e) {}
        if (!items.length) return;
        const original = btn.textContent;
        btn.disabled = true;
        try {
          const url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
          await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const cartItems = document.querySelector('cart-items-component');
          if (cartItems) {
            await customElements.whenDefined('cart-items-component');
            if (cartItems.fetchCartData) await cartItems.fetchCartData();
          }
          const opener = this.querySelector('[data-open-cart]');
          if (opener) opener.click();
        } catch (e) {
          console.warn('[nibsy] add all failed', e);
        }
        btn.disabled = false;
        btn.textContent = original;
      });
    }
  }
  if (!customElements.get('nibsy-collection')) customElements.define('nibsy-collection', NibsyCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibsy-product-grid"] && !Shopify.designMode) return;
  try {
    
  class NibsyProductGrid extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.track = this.querySelector('[data-track]');
      this.colsD = parseInt(this.dataset.colsD, 10) || 4;
      this.arrowsD = this.dataset.arrowsD !== 'false';
      this.page = 0;
      this.active = this.tabs.length ? (this.tabs[0].dataset.index || '0') : '0';
      this.mq = window.matchMedia('(min-width: 750px)');

      this.tabs.forEach((t) => t.addEventListener('click', () => {
        this.tabs.forEach((x) => x.classList.remove('is-on'));
        t.classList.add('is-on');
        this.active = t.dataset.index || '0';
        this.page = 0;
        this.render();
      }));

      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.move(-1));
      if (next) next.addEventListener('click', () => this.move(1));
      this.mq.addEventListener('change', () => { this.page = 0; this.render(); });
      this.render();
    }

    matching() {
      if (!this.tabs.length) return this.cards;
      return this.cards.filter((c) => (c.dataset.tab || '0') === this.active);
    }

    move(dir) {
      if (!this.mq.matches) {
        const card = this.cards.find((c) => !c.hidden);
        const w = card ? card.offsetWidth + 16 : 240;
        this.track.scrollBy({ left: dir * w, behavior: 'smooth' });
        return;
      }
      if (!this.arrowsD) return;
      const pages = Math.max(1, Math.ceil(this.matching().length / this.colsD));
      this.page = (this.page + dir + pages) % pages;
      this.render();
    }

    render() {
      const match = this.matching();
      this.cards.forEach((c) => { c.hidden = !match.includes(c); });
      // Paginate one row at a time on desktop only when arrows are enabled
      if (this.mq.matches && this.arrowsD && match.length > this.colsD) {
        const start = this.page * this.colsD;
        match.forEach((c, i) => { c.hidden = i < start || i >= start + this.colsD; });
      }
    }
  }
  if (!customElements.get('nibsy-product-grid')) customElements.define('nibsy-product-grid', NibsyProductGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibsy-product"] && !Shopify.designMode) return;
  try {
    
  class NibsyProduct extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.dataset.variants || '[]'); } catch (e) { this.variants = []; }
      this.formInput = this.querySelector('[data-variant-id]');
      this.swatches = Array.from(this.querySelectorAll('[data-swatch]'));
      this.priceEls = Array.from(this.querySelectorAll('[data-price]'));
      this.priceBtn = this.querySelector('[data-price-btn]');
      this.colorNames = Array.from(this.querySelectorAll('[data-color-name]'));
      this.atcBtns = Array.from(this.querySelectorAll('[data-atc]'));

      this.swatches.forEach((sw) => sw.addEventListener('click', () => this.selectSwatch(sw)));

      const mainImg = this.querySelector('[data-main-img]');
      this.querySelectorAll('[data-thumb]').forEach((t) => t.addEventListener('click', () => {
        if (mainImg && t.dataset.src) mainImg.src = t.dataset.src;
        this.querySelectorAll('[data-thumb]').forEach((x) => x.classList.remove('is-on'));
        t.classList.add('is-on');
      }));

      const qty = this.querySelector('[data-qty-input]');
      const dec = this.querySelector('[data-qty-dec]');
      const inc = this.querySelector('[data-qty-inc]');
      if (dec && qty) dec.addEventListener('click', () => { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (inc && qty) inc.addEventListener('click', () => { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

      const mainAdd = this.querySelector('[ref="addToCartButton"]');
      const stickyAdd = this.querySelector('[data-sticky-add]');
      if (stickyAdd && mainAdd) stickyAdd.addEventListener('click', () => mainAdd.click());

      // Sticky bar appears once the main Add to cart scrolls out of view, and tucks
      // away again when the footer is reached so it never covers it.
      const stickybar = this.querySelector('.nibsy-stickybar');
      const anchor = mainAdd || this.querySelector('[data-atc]:not([data-sticky-add])');
      const footer = document.querySelector('.nibsy-footer');
      if (stickybar && anchor && 'IntersectionObserver' in window) {
        let pastAtc = false, atFooter = false;
        const update = () => stickybar.classList.toggle('is-visible', pastAtc && !atFooter);
        new IntersectionObserver((entries) => {
          entries.forEach((e) => { pastAtc = !e.isIntersecting && e.boundingClientRect.top < 0; });
          update();
        }, { threshold: 0 }).observe(anchor);
        if (footer) {
          new IntersectionObserver((entries) => {
            entries.forEach((e) => { atFooter = e.isIntersecting; });
            update();
          }, { threshold: 0 }).observe(footer);
        }
      }
    }

    selectSwatch(sw) {
      this.swatches.forEach((x) => x.classList.remove('is-on'));
      sw.classList.add('is-on');
      const value = sw.dataset.value;
      const accent = sw.dataset.accent;
      const variant = this.variants.find((v) => v.value === value);
      if (variant && this.formInput) this.formInput.value = variant.id;
      if (variant) {
        this.priceEls.forEach((el) => { el.textContent = variant.price; });
        if (this.priceBtn) this.priceBtn.textContent = variant.price;
      }
      this.colorNames.forEach((el) => { el.textContent = value; });
      if (accent) this.atcBtns.forEach((b) => b.style.setProperty('--nibsy-accent', accent));
    }
  }
  if (!customElements.get('nibsy-product')) customElements.define('nibsy-product', NibsyProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibsy-recommendations"] && !Shopify.designMode) return;
  try {
    
  class NibsyRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      // Already has cards (fallback / editor render) — just reveal.
      if (this.querySelector('[data-rec-card]')) { this.hidden = false; this.dataset.loaded = '1'; return; }
      const pid = this.dataset.productId;
      if (!pid) return;
      const url = `${this.dataset.url}?section_id=${this.dataset.sectionId}&product_id=${pid}&limit=${this.dataset.limit || 5}&intent=${this.dataset.intent || 'related'}`;
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const grid = doc.querySelector('.nibsy-recs__grid');
          const myGrid = this.querySelector('.nibsy-recs__grid');
          if (grid && myGrid && grid.querySelector('[data-rec-card]')) {
            myGrid.innerHTML = grid.innerHTML;
            this.hidden = false;
          }
          this.dataset.loaded = '1';
        })
        .catch(() => {});
    }
  }
  if (!customElements.get('nibsy-recommendations')) customElements.define('nibsy-recommendations', NibsyRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nibsy-reviews"] && !Shopify.designMode) return;
  try {
    
  class NibsyReviews extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-review]'));
      this.filter = this.querySelector('[data-filter]');
      this.pos = this.querySelector('[data-pos]');
      this.role = '';
      this.index = 0;
      this.mq = window.matchMedia('(min-width: 750px)');
      if (this.filter) this.filter.addEventListener('change', () => { this.role = this.filter.value; this.index = 0; this.render(); });
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.move(-1));
      if (next) next.addEventListener('click', () => this.move(1));
      this.mq.addEventListener('change', () => { this.index = 0; this.render(); });
      this.render();
    }
    matching() { return this.cards.filter((c) => !this.role || c.dataset.role === this.role); }
    perView() {
      if (this.dataset.layout === 'grid') return Math.max(1, this.matching().length);
      return this.mq.matches ? (parseInt(this.dataset.cols, 10) || 3) : 1;
    }
    move(dir) {
      const match = this.matching();
      const per = this.perView();
      const pages = Math.max(1, match.length - per + 1);
      this.index = (this.index + dir + pages) % pages;
      this.render();
    }
    render() {
      const match = this.matching();
      const per = this.perView();
      this.cards.forEach((c) => { c.hidden = true; });
      const start = Math.min(this.index, Math.max(0, match.length - per));
      match.slice(start, start + per).forEach((c) => { c.hidden = false; });
      if (this.pos && match.length) this.pos.textContent = (Math.min(start + 1, match.length)) + ' / ' + match.length;
    }
  }
  if (!customElements.get('nibsy-reviews')) customElements.define('nibsy-reviews', NibsyReviews);

  } catch(e) { console.error(e); }
})();
})();
